import {
    SimpleForm,
    Toolbar,
    SaveButton,
    useRecordContext,
    useResourceContext,
    usePermissions,
    useTranslate,
} from "react-admin";
import { RaDeleteButton } from "shared/src/components/buttons/RaDeleteButton";

export const SimpleFormWithPermissions = ({ deleteButton = true, ...props }) => {
    return (
        <SimpleForm
            {...props}
            toolbar={
                props.toolbar ? (
                    props.toolbar
                ) : (
                    <ToolbarWithPermissions deleteButton={deleteButton} {...props} />
                )
            }
        />
    );
};

const ToolbarWithPermissions = ({ deleteButton = true, ...props }) => {
    const record = useRecordContext();
    const resource = useResourceContext();
    const attribute = "delete";
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading) {
        return <></>;
    }
    return (
        <Toolbar {...props} sx={{ display: "flex", justifyContent: "space-between" }}>
            <SaveButton title={translate("equip.save")} />
            {deleteButton &&
                permissions.vote({
                    resource,
                    attribute,
                    subject: record,
                }) && <RaDeleteButton mutationMode="pessimistic" />}
        </Toolbar>
    );
};
